<script setup>
import { computed } from 'vue';
import { PopoverRoot, PopoverTrigger } from 'reka-ui';
import { PopoverContent } from 'Components/primitives/popover';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: Boolean,
  /**
   * Keeps the menu open when clicking outside or pressing escape.
   */
  persistent: Boolean,
  /**
   * Which side of the activator the menu opens on.
   */
  side: {
    type: String,
    default: 'bottom'
  },
  /**
   * How the menu aligns relative to the activator.
   */
  align: {
    type: String,
    default: 'start'
  }
});

const menuModel = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});

function onDismiss(event) {
  if (props.persistent) event.preventDefault();
}
</script>

<template>
  <popover-root v-model:open="menuModel">
    <popover-trigger as-child>
      <slot name="activator"></slot>
    </popover-trigger>

    <popover-content
        class="context-menu p-0 rounded-md border-[rgba(7,23,39,0.17)] shadow-[0px_6px_15.3px_rgba(13,48,72,0.09)]"
        :side="side"
        :align="align"
        @pointer-down-outside="onDismiss"
        @escape-key-down="onDismiss"
        @focus-outside="onDismiss"
        @interact-outside="onDismiss"
    >
      <slot name="content" />
    </popover-content>
  </popover-root>
</template>
